<template>
  <div>
    <role-list v-show="activeKey===1" ref="list" @add="add" @getDetail="getDetail"/>
    <menu-of-role v-show="activeKey===2" ref="detail" @back="back"/>
  </div>
</template>
<script>
import RoleList from '@/views/config/role_authority/RoleList.vue'
import MenuOfRole from '@/views/config/role_authority/RoleDetail.vue'

export default {
  name: 'RoleAuthority',
  components: { MenuOfRole, RoleList },
  data() {
    return {
      activeKey: 1
    }
  },
  methods: {
    back() {
      this.activeKey = 1
    },
    getDetail(record) {
      this.activeKey = 2
      this.$refs.detail.refresh({ id: record.id })
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.add()
    }
  }
}
</script>